import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Grid2,
  Paper,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  Divider,
  IconButton
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Close as CloseIcon } from '@mui/icons-material';
import CoursePauseResetIcon from "Assets/Images/CoursePauseResetGuide.png";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import PrimaryTable from 'Components/Common/PrimaryTable';

// --- Reusable Helper Components for better structure ---
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8',
    }),
  },
}));


const Header = () => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'backgroun.default', p: 2 }}>
    <Typography variant="h5" fontWeight="bold">Course Pause</Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box sx={{ width: '150px' }}>
        <Typography variant="body2" color="secondary.light" fontSize={"14px"} fontWeight={700} mb={1}>Step 1 of 5</Typography>
        <BorderLinearProgress variant="determinate" value={20} />
      </Box>
      <IconButton>
        <CloseIcon color="action" />
      </IconButton>
    </Box>
  </Box>
);

const VideoPlayerCard = () => (
  <Paper variant="outlined" sx={{ borderRadius: '8px', maxWidth: 380 }}>
    <Box sx={{ position: 'relative', textAlign: 'center' }}>
      <img
        src={CoursePauseResetIcon} // Make sure this image exists in your public folder
        alt="Pause and Reset Demo"
        style={{ width: '100%', display: 'block', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
    />
    </Box>
    <Typography sx={{ p: 2, textAlign: 'center', color: 'secondary.light', fontSize: "16px", fontWeight: 700 }}>
      Applying for Pause and Reset - Demo
    </Typography>
  </Paper>
);

// --- Main Page Component ---
const CoursePauseFrom = () => {
  const [reason, setReason] = useState('');

  const columns = [
    { label: "Features", accessor: "Features"},
    { label: "Course Active", accessor: "CourseActive", type: "Status" },
    { label: "Course Pause", accessor: "CoursePause", type: "Status" }
  ];

  const data = [
    {Features: "EMI Payment", CourseActive: "Active", CoursePause: "Active"},
    {Features: "Mentor Sessions", CourseActive: "Active", CoursePause: "Active"},
    {Features: "Streak", CourseActive: "Active", CoursePause: "Optional"},
    {Features: "TA and help request access", CourseActive: "Active", CoursePause: "Active"},
    {Features: "Archived Videos and content", CourseActive: "Active", CoursePause: "Active"},
    {Features: "Placement Assistance", CourseActive: "Active", CoursePause: "Active"},
    {Features: "Existing Projects", CourseActive: "Active", CoursePause: "Active"},
    {Features: "New Projects", CourseActive: "Active", CoursePause: "Inactive"},
  ]

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const reasons = [
    "I want to work on my backlog",
    "Family / Work Commitments",
    "Health Issues",
    "Other"
  ];

  return (
    <>
      <Header />
      <Box sx={{ width: '100%', bgcolor: 'white', p: { xs: 4, md: 8 }, borderRadius: '8px' }}>
      {/* <Box sx={{ maxWidth: '1200px', mx: 'auto', bgcolor: 'white', p: { xs: 2, md: 4 }, borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}> */}
        <Box sx={{ pb: 4 }}>
          <Grid container justifyContent="space-between">
            {/* Left Column: Form */}
            <Grid item>
              <Typography variant="h4" color="secondary.light" fontWeight={550} gutterBottom>
                Reason For Course Pause
              </Typography>
              <Typography variant="body1" color="secondary.light" fontSize={"16px"} fontWeight={550} mb={3}>
                Select only one option applicable to you
              </Typography>

              <RadioGroup value={reason} onChange={handleReasonChange}>
                {reasons.map((text, index) => (
                  <FormControlLabel
                    key={index}
                    value={text}
                    control={<Radio />}
                    label={text}
                    sx={{ mb: 1 }}
                  />
                ))}
              </RadioGroup>
            </Grid>

            {/* Right Column: Video */}
            <Grid item>
              <VideoPlayerCard />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 3 }}>
                <Button
                  variant="contained"
                  disabled={!reason}
                  sx={{ px: 4 }}
                >
                  Next
                </Button>
              </Box>
              
            </Grid>
          </Grid>

        </Box>

        <Divider />

        <Box display={"flex"} gap="8px" mt={3} mb={1}>
          <Typography color="secondary.light" fontSize={"16px"} fontWeight={700} variant="title">Status of features during the pause</Typography>
          <Typography color="secondary.light" fontSize={"16px"} fontWeight={500} variant="subtitle">(More features may be included later)</Typography>
        </Box>

        <Grid2 spacing={2} container>
          <Grid2 size={6}>
            <PrimaryTable columns={columns} data={data} />
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default CoursePauseFrom;